import React from 'react';
import bemHelper from 'react-bem-helper';

import ourProductsAnalytics from '../../analytics/our-products';
import Product from '../Product/Product';
import './styles.scss';

const bem = bemHelper({ prefix: 'toga-', name: 'top-products' });
const bemCard = bemHelper({ prefix: 'toga-', name: 'top-product-card' });

class ProductsModule extends React.Component {

  static propTypes = {
    topProducts: React.PropTypes.shape({
      highlightedText1: React.PropTypes.string,
      highlighted2: React.PropTypes.string,
      products: React.PropTypes.array,
    }),
  };

  constructor(props) {
    super(props);

    this.state = {
      storefrontUrl: undefined,
    };
  }

  componentDidMount() {
    if (!location) {
      // test env
      return;
    }

    const pathContainsPartners = location.pathname.startsWith('/partners/');

    this.setState({
      storefrontUrl: pathContainsPartners
        ? `${location.pathname}/products${location.search}`
        : `/partners${location.pathname}/products${location.search}`,
    });
  }

  render() {
    const { topProducts, partnerName } = this.props;
    const numberCards = topProducts && topProducts.products
        .concat([topProducts.highlightedText1, topProducts.highlightedText2])
        .filter(card => !!card)
        .length;

    const gridClasses = {
      'max-width-sm': topProducts && topProducts.products && topProducts.products.length <= 5,
      expanded: numberCards > 10
    };

    return (
      <div {...bem()}>
        <div {...bem('title-container')}>
          <h2 {...bem('title')}>Our Products</h2>
          {this.state.storefrontUrl &&
          <a onClick={ourProductsAnalytics.registryViewAll}
             href={this.state.storefrontUrl}
             {...bem('view-all')}>view all <span
            className="sr-only">products</span>
          </a>}
        </div>
        {topProducts &&
        <div{...bem('wrapper', gridClasses)}>
          {
            topProducts.products &&
            topProducts.products.map((product, index) => {
              return (
                <Product product={product}
                         key={index}
                         classes={gridClasses}
                         partnerName={partnerName}/>
              );
            })
          }

          {
            topProducts.products &&
            topProducts.products.length > 5 && topProducts.highlightedText1 &&
            <div {...bemCard(null, 'primary', gridClasses)}>
                        <span>
                          {topProducts && topProducts.highlightedText1}
                        </span>
            </div>
          }

          {
            topProducts.products &&
            topProducts.products.length > 5 &&
            <div {...bemCard(null, 'blank', gridClasses)}></div>
          }

          {
            topProducts.products &&
            topProducts.products.length > 5 &&
            <div {...bemCard(null, 'blank', gridClasses)}></div>
          }

          {
            topProducts.products &&
            topProducts.products.length > 5 && topProducts.highlightedText2 &&
            <div {...bemCard(null, 'secondary')}>
                        <span>
                          {topProducts && topProducts.highlightedText2}
                        </span>
            </div>
          }

        </div>}
      </div>
    );
  }

}

export default ProductsModule;



// WEBPACK FOOTER //
// ./src/components/storefront/components/ProductsModule/ProductsModule.js